<i nz-icon [nzType]="icon"></i>
<span>{{name}}</span>